/* eslint-disable */
/**
 * SektionsHeader — Label + opdateringstidsstempel + refresh-ikon (Lucide RefreshCw)
 *
 * Props:
 *   label         string  — sektionens titel
 *   opdateret     string | Date | null  — ISO-tidsstempel for seneste opdatering
 *   onRefresh     fn      — klik-handler på refresh-ikon (undefined = ingen ikon)
 *   refreshing    bool    — viser spinner på refresh-ikon
 *   højreInnhold  ReactNode  — ekstra indhold til højre (fx StatusBadge)
 *   style         obj
 */

import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { TEKST, STATUS, KANT, SPACING, TYPE } from './tokens';

function formatOpdateret(ts) {
  if (!ts) return null;
  const d = new Date(ts);
  if (isNaN(d)) return null;
  const diffS = Math.round((Date.now() - d) / 1000);
  if (diffS < 10)   return 'Nu';
  if (diffS < 60)   return `${diffS}s siden`;
  if (diffS < 3600) return `${Math.round(diffS / 60)} min siden`;
  return d.toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' });
}

export default function SektionsHeader({ label, opdateret, onRefresh, refreshing = false, højreIndhold, style = {} }) {
  const opdTekst = formatOpdateret(opdateret);

  return (
    // OS-09: flexWrap:'wrap' sikrer at badges aldrig løber off-screen på 360px mobil.
    // gap:10 bibeholder afstand mellem elementer ved wrap.
    <div style={{
      display:      'flex',
      alignItems:   'center',
      flexWrap:     'wrap',
      gap:          10,
      marginBottom: SPACING.headerMB,
      ...style,
    }}>
      <span style={{ ...TYPE.sektHeader, color: TEKST.primær, flex: 1 }}>
        {label}
      </span>

      {højreIndhold}

      {opdTekst && (
        <span style={{ fontSize: 11, color: TEKST.sekundær, opacity: 0.7 }}>
          {opdTekst}
        </span>
      )}

      {onRefresh && (
        <button
          onClick={onRefresh}
          title="Opdater"
          style={{
            background:  'none',
            border:      `1px solid ${KANT.standard}`,
            borderRadius: 5,
            color:        TEKST.sekundær,
            lineHeight:  1,
            padding:     '4px 7px',
            cursor:      refreshing ? 'default' : 'pointer',
            opacity:     refreshing ? 0.5 : 1,
            transition:  'border-color .15s, color .15s',
            display:     'flex',
            alignItems:  'center',
            justifyContent: 'center',
          }}
          disabled={refreshing}
          onMouseEnter={e => { if (!refreshing) { e.currentTarget.style.borderColor = KANT.aktiv; e.currentTarget.style.color = TEKST.primær; } }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = KANT.standard; e.currentTarget.style.color = TEKST.sekundær; }}
        >
          {refreshing
            ? <span style={{ fontSize: 13 }}>…</span>
            : <RefreshCw size={13} />
          }
        </button>
      )}
    </div>
  );
}
